<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import {sort, copyObjectProperties} from "../lib/lib";
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import AgentEditModal from "./AgentEditModal.svelte";


    let agents = null;
    let selectedId = 0;
    let editedId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE AGENT', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'contact_person', title: 'CONTACT', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'phone', title: 'PHONE', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            agents = result;
            app.setAgents(result);
        }

        const onFailure = err => {
        };

        R.handle(R.agent.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        agents = sort(agents, column.key, column.sort_way === 'ASC');
    }

    const onCreate = () => {
        editedId = 0;
    }

    const onEdit = (agent) => {
        selectedId = agent.id;
        editedId = agent.id;
    }

    const closeAgent = data => {
        if (data) {
            let properties = ['id', 'name', 'contact_person', 'phone', 'email'];

            let agent = agents.find(x => x.id == data.id);
            if (agent) {
                copyObjectProperties(data, agent, properties);
                agents = agents;
            } else {
                agents = [copyObjectProperties(data, properties), ...agents];
            }

            app.setAgents(agents);
        }
        editedId = null;
    }

    const onDelete = (agent) => {
        Alert.delete("Delete agent", `This will permanently delete agent "${agent.name}".\nAre you sure?`, () => deleteAgent(agent.id));
    }

    const deleteAgent = (id) => {
        const onSuccess = result => {
            agents = agents.filter(x => x.id !== result);
            app.setAgents(agents);
            Notifier.showMessage("Agent deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Delete agent", `Agent is related with ${err.params.reservations} reservations!\nYou can not delete this agent.`);
            }
        };

        R.handle(R.agent.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }


    const addUser = (agent) => {
        app.editUser({id: 0, agent_id: agent.id}, closeUser);
    }

    const closeUser = () => {
        app.clearEditUser();
    }

    load();
</script>

<Route exact>
    <PageHeader title="Agents" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

    {#if agents}
        <div class="panel mb-4">
            <div class="panel-body">
                {#if agents.length}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each agents as item}
                            <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                                <td>
                                    <button class="btn-reset is-link text-start" on:click="{ () => onEdit(item) }">
                                        { item.name }
                                    </button>
                                    <div class="hidden-xl hidden-lg hidden-md mt-2">
                                        {#if item.phone}
                                            <div><a href="tel:{item.phone}">{item.phone}</a></div>
                                        {/if}
                                        {#if item.email}
                                            <div><a href="mailto:{item.email}">{item.email}</a></div>
                                    {/if}
                                    </div>
                                </td>
                                <td class="text-gray hidden-sm hidden-xs">
                                    {item.contact_person}
                                </td>
                                <td class="text-gray hidden-sm hidden-xs">
                                    {#if item.phone}
                                        <a href="tel:{item.phone}">{item.phone}</a>
                                    {/if}
                                </td>
                                <td class="text-gray hidden-sm hidden-xs">
                                    {#if item.email}
                                        <a href="mailto:{item.email}">{item.email}</a>
                                    {/if}
                                </td>
                                <td class="button-column" title="add user to agent">
                                    <button class="btn-reset btn-action p-2" on:click="{ () => addUser(item) }">
                                        <AppIcon icon="user-plus-solid" size="16"/>
                                    </button>
                                </td>
                                <td class="button-column" title="delete agent">
                                    <button class="btn-reset btn-action p-2" on:click="{ () => onDelete(item) }">
                                        <AppIcon icon="trash" size="16"/>
                                    </button>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-pad">
                        <p>
                            There are no agents
                        </p>
                        <button class="btn btn-primary" on:click={onCreate}>CREATE AGENT</button>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
</Route>

{#if editedId != null}
    <AgentEditModal agentId={editedId} closeCallback={closeAgent}/>
{/if}